export const transformationsCache = new Map<string, unknown>()
